<template>
  <div class="modal sign-modal">
    <div class="overlay" @click="$emit('closeSignInModal')"></div>
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img class="close" @click="$emit('closeSignInModal')" src="./../assets/close.svg" />
            <div :class="['form-fields login-content', { hidden: !loginContentVisible }]">
              <div class="form-fields-wrapper">
                <div class="title small">{{ $t('Login') }}</div>
                <label>
                  <div class="desc">{{ $t('E-mail:') }}</div>
                  <input type="email" :placeholder="$t('Email')" v-model="email" />
                </label>
                <label>
                  <div class="desc">{{ $t('Password:') }}</div>
                  <input type="password" :placeholder="$t('Password')" v-model="pass" />
                </label>
                <div class="cta-container">
                  <button class="button" @click="submitLogin">
                    <span>{{ $t('Log In') }}</span>
                  </button>
                </div>
                <transition name="slide">
                  <div v-if="$parent.error" class="error-desc desc red">
                    {{ $parent.error }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignInModal",
  props: {
    isVerified: Boolean
  },
  components: {},
  data: function () {
    return {
      loginContentVisible: true,
      email: "",
      pass: "",
    };
  },
  mounted() {},
  methods: {
    switchToLogin() {
      this.$parent.clearError();
      setTimeout(() => {
        this.loginContentVisible = true;
      }, 100);
    },
    submitLogin() {
      let loginData = {
        username: this.email,
        password: this.pass,
      };
      this.$emit("login2", loginData);
    },
  },
};
</script>
